// @flow

// XXX: refactor with `@gandi/layout`?

import * as React from 'react';

import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import type { To } from 'react-router-dom';

import { Svg } from '@gandi/ui';

import type { NavigationItemType, NavigationItem as Item } from '../../types';

import styles from './NavigationItem.scss';

export type Props = {
  item: Item,
  type?: NavigationItemType,
  collapsed?: boolean,
  className?: string,
  ...
};

const Component = ({
  to,
  href,
  activeClassName,
  onlyActiveOnIndex,
  refCallback,
  className,
  ...extraProps
}: {
  to?: To,
  href?: string,
  activeClassName?: string,
  onlyActiveOnIndex?: boolean,
  refCallback?: (node: React.ElementRef<any>) => void,
  className?: string,
  ...
}) =>
  to ? (
    // $FlowFixMe[cannot-spread-inexact]
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(isActive ? activeClassName : undefined, className)
      }
      end={onlyActiveOnIndex}
      {...extraProps}
    />
  ) : (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a {...extraProps} ref={refCallback} href={href} className={className} />
  );

function NavigationItem({
  item,
  type = 'main',
  collapsed,
  className,
  ...extraProps
}: Props) {
  const rootClasses = clsx(
    styles.root,
    styles[type],
    {
      [styles.isActive]: item.active,
      [styles.isCollapsed]: collapsed,
    },
    className,
  );

  return (
    // $FlowFixMe[cannot-spread-inexact]
    <Component
      to={item.to}
      href={item.href}
      activeClassName={styles.isActive}
      onlyActiveOnIndex={item.onlyActiveOnIndex}
      className={rootClasses}
      {...extraProps}
    >
      {type === 'main' && item.icon && (
        <Svg name={item.icon} className={styles.icon} />
      )}
      <span className={styles.label}>{item.title}</span>
    </Component>
  );
}

export default (React.memo<Props>(NavigationItem): React.ComponentType<Props>);
